module.exports = __webpack_public_path__ + "static/media/illustration_troca de pontos.119956a4.svg";